<template>
	<div class="newListDiv">
		<div class="titleBox flexDiv">
			<p>
				<em>信息公告</em>
				<span>INFORMATION ANNOUNCEMENT</span>
			</p>
			<a v-if="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s">
				<router-link :to="moreLink"><i>查看更多>></i></router-link>
			</a>
		</div>
		<ul class="newListUl">
			<li v-for="(item,index) in xxggList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
				<a :href="item.Url" class="flexDiv">
					<p>{{item.Title}}</p>
					<i>{{item.ShowTime}}</i>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'djgg',
		props:{
			xxggList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/xxggList.vue